// extracted by mini-css-extract-plugin
export var animationContainer = "_hs-0";
export var asteriskIcon = "_hs-8";
export var conversationLeftSection = "_hs-4";
export var conversationListItem = "_hs-3";
export var conversationMiddleSection = "_hs-5";
export var conversationRightSection = "_hs-6";
export var detailsContent = "_hs-1";
export var listContainer = "_hs-7";
export var modalContent = "_hs-2";